module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <div class="character-properties"></div>\n    <div class="action-properties"></div>\n    <div class="analytics-properties"></div>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/textWidget/TextWidgetPropertiesView.tpl
// module id = 2072
// module chunks = 0